/*
 * @Description: 签署意愿认证
 * @Author: ljl
 * @Date: 2024-03-12 
 */
import VALIDATOR from "./../../../FormVerification/validator";

export const handledByRule = {
  operatorName: [{ required: true, message: " ", trigger: ["blur","change"] }],
  operatorMobile: [{ required: true, message: " ", trigger: ["blur","change"] }],
  smsCode: [{ required: true, validator: VALIDATOR.vdtCheckNum, trigger: ["blur","change"] }],
};


// WEBPACK FOOTER //
// ./src/views/indexStatistic/vdt/form_validata.js